import { jsx as _jsx } from "react/jsx-runtime";
import { ContentSection } from "@cinch-labs/design-system";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import React from "react";
export var ArticleBody = function(param) {
    var body = param.body;
    if (!body || Object.keys(body).length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ContentSection, {
        children: renderWithResolver(body)
    });
};
